import { useInvoiceComplianceMode } from '@features/invoices/hooks/useInvoiceComplianceMode'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useOrganizationUiSetup } from '../../../hooks/useOrganizationUiSetup'

export const useShouldShowSiretPendingAssignmentCheckbox = (): boolean => {
  const { organization } = useUserOrganization()
  const { isUiSetupShineInvoicingAccounting, isUiSetupSupernavInvoicingAccounting } = useOrganizationUiSetup()
  const { isFrenchComplianceMode } = useInvoiceComplianceMode()

  const isFrenchCompany =
    (isUiSetupShineInvoicingAccounting || isUiSetupSupernavInvoicingAccounting) && isFrenchComplianceMode
  const hasNoRegistrationNo = !organization?.registrationNo

  return isFrenchCompany && hasNoRegistrationNo
}
